import { PostgrestResponse } from '@supabase/supabase-js';
import { ICardapioDiario } from '../../../types/tables/ICardapioDiario'
import { BaseMultiTenantService } from '../base/BaseMultiTenantService'

/**
 * Serviço para gerenciamento de cardápios diários
 */
export class CardapioDiarioService extends BaseMultiTenantService<ICardapioDiario> {
  constructor() {
    super('cardapio_diario', ['titulo', 'descricao'], 'fk_id_organizacao')
  }

  /**
   * Busca cardápio por data específica
   */
  async getByData(organizationId: number, data: string): Promise<PostgrestResponse<ICardapioDiario[]>> {
    const { data: cardapios, error } = await this.client
      .from(this.tableName)
      .select('*')
      .eq(this.organizationIdField, organizationId)
      .eq('data_cardapio', data)
      .eq('ativo', true)
      .is('deleted_at', null)
      .order('periodo')

    if (error) {
      throw new Error(`Erro ao buscar cardápio por data: ${error.message}`)
    }

    return { data: cardapios || [], error } as PostgrestResponse<any[]>
  }

  /**
   * Busca cardápio de hoje
   */
  async getHoje(organizationId: number): Promise<PostgrestResponse<ICardapioDiario[]>> {
    const hoje = new Date().toISOString().split('T')[0]
    return this.getByData(organizationId, hoje)
  }

  /**
   * Busca cardápios por período
   */
  async getByPeriodo(organizationId: number, periodo: string): Promise<PostgrestResponse<ICardapioDiario[]>> {
    const { data: cardapios, error } = await this.client
      .from(this.tableName)
      .select('*')
      .eq(this.organizationIdField, organizationId)
      .eq('periodo', periodo)
      .eq('ativo', true)
      .is('deleted_at', null)
      .order('data_cardapio')

    if (error) {
      throw new Error(`Erro ao buscar cardápio por período: ${error.message}`)
    }

    return { data: cardapios || [], error } as PostgrestResponse<any[]>
  }
}

export const cardapioDiarioService = new CardapioDiarioService()
